export default __webpack_public_path__ + "static/cer-1-0aa484f605638044535a83242e39a64d.webp";